import { render } from "./ClientVersionForm.vue?vue&type=template&id=b655fb1c&scoped=true"
import script from "./ClientVersionForm.vue?vue&type=script&lang=js"
export * from "./ClientVersionForm.vue?vue&type=script&lang=js"

import "./ClientVersionForm.vue?vue&type=style&index=0&id=b655fb1c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b655fb1c"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QEditor from 'quasar/src/components/editor/QEditor.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QCheckbox,QTooltip,QSelect,QToggle,QEditor});
